import loadingPackages from "./img/loadingPackages.webm";

const KartografSpinner = (props) => {
  return (
    <div
      className={`epaka-d-flex epaka-flex-column align-items-center justify-content-center`}
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        className={"epaka-ml-auto epaka-mr-auto"}
        style={props.size !== null ? { width: props.size + "rem" } : {}}
      >
        <source src={loadingPackages} type="video/webm" />
      </video>
      {/*<img*/}
      {/*  className={'ml-auto mr-auto'}*/}
      {/*  style={size !== null ? { width: size + 'rem' } : {}}*/}
      {/*  src={'/img/form/loadingPackages.gif'}*/}
      {/*></img>*/}
    </div>
  );
};

export default KartografSpinner;
